import logo from "../assets/logo.png";
import { fontstyle1 } from "./fonts";

const Logo = () => {
  return (
    <div className="flex items-center justify-center">
      <img src={logo} alt="logo" className="w-5" />
      <div className="h-6 ml-1 w-[2px] bg-[#494949] rounded"></div>
      <div className="ml-1 text-lg" style={fontstyle1}>
        dofeedbackin
      </div>
    </div>
  );
};

export default Logo;
